import { ERoutes } from "@utils/constants";
import { makePath } from "@utils/makePath";

export const copyLink = (route: ERoutes, id: string) => {
  if (!id) return;
  const url = `${location.origin}${makePath(route, id)}`;

  navigator.clipboard.writeText(url);
};
